/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentFlagType } from "./ShipmentFlagType";
import {
  ShipmentFlagTypeFromJSON,
  ShipmentFlagTypeFromJSONTyped,
  ShipmentFlagTypeToJSON,
  ShipmentFlagTypeToJSONTyped,
} from "./ShipmentFlagType";

/**
 *
 * @export
 * @interface ShipmentFlag
 */
export interface ShipmentFlag {
  /**
   *
   * @type {ShipmentFlagType}
   * @memberof ShipmentFlag
   */
  flagType: ShipmentFlagType;
  /**
   * Pre-formatted date the condition was first recorded. Omitted when no
   * date was captured.
   *
   * @type {string}
   * @memberof ShipmentFlag
   */
  since?: string;
}

/**
 * Check if a given object implements the ShipmentFlag interface.
 */
export function instanceOfShipmentFlag(value: object): value is ShipmentFlag {
  if (!("flagType" in value) || value["flagType"] === undefined) return false;
  return true;
}

export function ShipmentFlagFromJSON(json: any): ShipmentFlag {
  return ShipmentFlagFromJSONTyped(json, false);
}

export function ShipmentFlagFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentFlag {
  if (json == null) {
    return json;
  }
  return {
    flagType: ShipmentFlagTypeFromJSON(json["flagType"]),
    since: json["since"] == null ? undefined : json["since"],
  };
}

export function ShipmentFlagToJSON(json: any): ShipmentFlag {
  return ShipmentFlagToJSONTyped(json, false);
}

export function ShipmentFlagToJSONTyped(
  value?: ShipmentFlag | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    flagType: ShipmentFlagTypeToJSON(value["flagType"]),
    since: value["since"],
  };
}
